import { useQuery } from '@tanstack/react-query';
import API from '../../../../context/API';

export const SALES_DATA_QUERY_KEY = (storeId: string) => ['merchant', 'sales', 'currentMonth', storeId] as const;

// Store-scoped, so it waits for the active store to be resolved (profile →
// stores → this) instead of firing on mount — switching stores refetches
// automatically since storeId is part of the query key.
export const useSalesData = (storeId: string | null | undefined) => {
  return useQuery<number>({
    queryKey: SALES_DATA_QUERY_KEY(storeId || ''),
    queryFn: async () => {
      const token = localStorage.getItem('access_token');
      const today = new Date();
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      const res = await API.get('/analytics/sales', {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          startDate: startOfMonth.toISOString().split('T')[0],
          endDate: endOfMonth.toISOString().split('T')[0],
          store: storeId,
        },
      });

      if (res.data?.success) {
        const netSales = parseFloat(res.data.data.netSales) || 0;
        const grossSales = parseFloat(res.data.data.grossSales) || 0;
        return netSales || grossSales;
      }
      return 0;
    },
    enabled: !!storeId,
    staleTime: 60_000,
  });
};
